import { Workbox } from 'workbox-window';

export function register() {
  // Only register service worker in production
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const wb = new Workbox('/sw.js');

    wb.addEventListener('installed', (event) => {
      if (event.isUpdate) {
        if (confirm('New content is available! Click OK to refresh.')) {
          window.location.reload();
        }
      }
    });

    wb.addEventListener('activated', () => {
      console.log('Service worker activated');
    });

    wb.addEventListener('waiting', () => {
      console.log('Service worker waiting');
    });

    wb.register().catch((error) => {
      // Service workers are not supported in StackBlitz WebContainer
      if (error.message.includes('Service Workers are not yet supported')) {
        console.log('Service Workers are not supported in this environment');
        return;
      }
      console.error('Service worker registration failed:', error);
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}